module.exports = "https://trybtryb-legacy.web.app/img/rounded-outline-mobile.b85a59e7.svg";